import sptk from '../../libs/sptk'

class HeaderModule {
    constructor() {
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseEnterRichMenu = this.onMouseEnterRichMenu.bind(this);
        this.onMouseLeaveRichMenu = this.onMouseLeaveRichMenu.bind(this);
        this.onClickPanelTriger = this.onClickPanelTriger.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
        this.setInitialProps();
    }

    bindUI() {
        this.ui = {};
        this.ui.$body = document.body;
        this.ui.$header = document.querySelector('.js-header');
        this.ui.$navItems = document.querySelectorAll('.js-nav-item');
        this.ui.$navTriggerClose = document.querySelectorAll('.js-nav-trigger-close');
        this.ui.$navRichMenus = document.querySelectorAll('.js-nav-rich-menu');
        this.ui.$panelTrigers = document.querySelectorAll('.js-header-panel-trigger');
        this.ui.$panelTargets = document.querySelectorAll('.js-header-panel-target');
    }

    bindEvents() {
        this.isMobileTablet = sptk.utils.isMobileTablet || window.innerWidth < 1024 ? true : false;

        [].forEach.call(this.ui.$navItems, ($item, index) => {
            if (this.isMobileTablet) {
                $item.addEventListener('click', this.onTouchStart);
            } else {
                $item.addEventListener('mouseenter', this.onMouseEnter);
                $item.addEventListener('mouseleave', this.onMouseLeave);
            }

        });

        [].forEach.call(this.ui.$navTriggerClose, ($item, index) => {
            $item.addEventListener('click', this.onMouseLeave);
        });

        if (!this.isMobileTablet) {
            [].forEach.call(this.ui.$navRichMenus, ($item, index) => {
                $item.addEventListener('mouseenter', this.onMouseEnterRichMenu);
                $item.addEventListener('mouseleave', this.onMouseLeaveRichMenu);
            });
        }
        [].forEach.call(this.ui.$panelTrigers, ($item, index) => {
            $item.addEventListener('click', this.onClickPanelTriger);
        });

        window.addEventListener('resize', this.onWindowResize);
    }

    unbindEvents() {
        [].forEach.call(this.ui.$navItems, ($item, index) => {
            if (this.isMobileTablet) {
                $item.removeEventListener('click', this.onTouchStart);
            } else {
                $item.removeEventListener('mouseenter', this.onMouseEnter);
                $item.removeEventListener('mouseleave', this.onMouseLeave);
            }

        });

        [].forEach.call(this.ui.$navTriggerClose, ($item, index) => {
            $item.removeEventListener('click', this.onMouseLeave);
        });

        if (!this.isMobileTablet) {
            [].forEach.call(this.ui.$navRichMenus, ($item, index) => {
                $item.removeEventListener('mouseenter', this.onMouseEnterRichMenu);
                $item.removeEventListener('mouseleave', this.onMouseLeaveRichMenu);
            });
        }

        [].forEach.call(this.ui.$panelTrigers, ($item, index) => {
            $item.removeEventListener('click', this.onClickPanelTriger);
        });

        window.removeEventListener('resize', this.onWindowResize)
    }

    setInitialProps(e) {
        this.settings = [];
        this.activeMenu = {};
        this.isMenuHovered = false;
        this.timer = 100;

        [].forEach.call(this.ui.$navRichMenus, ($item, index) => {
            this.settings.push({
                el: $item,
                index: $item.getAttribute('data-index')
            });
        });

        this.panels = [];
        this.currentPanel = {};
        [].forEach.call(this.ui.$panelTargets, ($item, index) => {
            this.panels.push({
                el: $item,
                attr: $item.getAttribute('data-header-panel')
            });
        });
    }

    onWindowResize() {
        this.unbindEvents();
        this.bindEvents();

        if (this.isMobileTablet && this.isHeaderPanelOpened) {
            this.preventBodyScroll();
        } else {
            this.allowBodyScroll();
        }
    }

    onTouchStart(e) {
        if (e && e.cancelable) {
            e.stopPropagation();
            e.preventDefault();
        }
        const currentTarget = e.currentTarget;
        const index = currentTarget.getAttribute('data-index');

        if (this.activeMenu.$richMenu) {
            this.hideActiveMenu();
            this.closeRichMenu();
        } else {
            this.setActiveMenu(this.getRichMenu(index), currentTarget);
            this.openRichMenu();
        }
    }

    onMouseEnter(e) {
        const currentTarget = e.currentTarget;
        const index = currentTarget.getAttribute('data-index');

        clearTimeout(this.enterTimeout);

        this.enterTimeout = setTimeout(() => {
            clearTimeout(this.triggerTimeout);

            if (this.activeMenu.$richMenu) {
                this.hideActiveMenu();
            }
            this.setActiveMenu(this.getRichMenu(index), currentTarget);
            this.openRichMenu();

        }, this.timer - 50)
    }

    onMouseLeave(e) {
        if (e && e.cancelable) {
            e.stopPropagation();
            e.preventDefault();
        }
        clearTimeout(this.enterTimeout);

        if (!this.isMobileTablet) {
            this.triggerTimeout = setTimeout(() => {
                clearTimeout(this.triggerTimeout);

                if (!this.isMenuHovered && this.activeMenu.$richMenu) {
                    this.closeRichMenu();
                }
            }, this.timer);
        } else {
            if (this.activeMenu.$richMenu) {
                this.closeRichMenu();
            }
        }


    }

    onMouseEnterRichMenu() {
        this.isMenuHovered = true;
    }

    onMouseLeaveRichMenu() {
        clearTimeout(this.enterTimeout);

        this.triggerTimeout = setTimeout(() => {
            this.isMenuHovered = false;

            if (this.activeMenu.$richMenu) {
                this.closeRichMenu();
            }
        }, this.timer);

    }

    onClickPanelTriger(e) {
        if (e.cancelable) {
            e.preventDefault();
            e.stopPropagation();
        }
        const currentTarget = e.currentTarget.getAttribute('data-header-panel-target');

        this.panels.forEach(item => {
            if (currentTarget === item.attr) {
                if (this.currentPanel && this.currentPanel.el == item.el) {
                    this.hideHeaderPanel();
                    this.hideCurrentPanel();
                    this.currentPanel = {};
                } else {
                    this.hideCurrentPanel();
                    this.currentPanel = item;
                    this.showHeaderPanel();
                    this.closeRichMenu();
                    this.currentPanel.el.classList.add('is-active');
                }
            }
        });
    }

    getRichMenu(index) {
        return [...this.ui.$navRichMenus].filter(item => item.getAttribute('data-index') === index)[0]
    }

    hideCurrentPanel() {
        if (this.currentPanel.el) {
            this.currentPanel.el.classList.remove('is-active');
        }
    }

    showHeaderPanel() {
        this.ui.$header.classList.add('is-burger-opened');
        this.ui.$header.setAttribute('data-current-panel', this.currentPanel.attr);
        this.preventBodyScroll();
        this.isHeaderPanelOpened = true;
    }

    hideHeaderPanel() {
        this.ui.$header.classList.remove('is-burger-opened');
        this.ui.$header.setAttribute('data-current-panel', '');
        this.allowBodyScroll();
        this.closeRichMenu();
        this.isHeaderPanelOpened = false;
    }

    setActiveMenu(richMenu, navItem) {
        if (richMenu && navItem) {
            this.activeMenu = {
                $richMenu: richMenu,
                $navItem: navItem
            }
        } else {
            this.unsetActiveMenu();
        }
    }

    unsetActiveMenu() {
        this.activeMenu = {};
    }

    hideActiveMenu() {
        if (this.activeMenu.$richMenu) {
            this.activeMenu.$richMenu.classList.remove('is-visible');
            this.activeMenu.$navItem.classList.remove('is-hover');
        }
    }

    showActiveMenu() {
        if (this.activeMenu.$richMenu) {
            this.activeMenu.$richMenu.classList.add('is-visible');
            this.activeMenu.$navItem.classList.add('is-hover');
        }
    }

    showRichMenu() {
        if (this.activeMenu.$richMenu) {
            this.ui.$header.classList.add('is-opened');
        }
    }

    hideRichMenu() {
        this.ui.$header.classList.remove('is-opened');
    }

    closeRichMenu() {
        this.hideActiveMenu();
        this.hideRichMenu();
        this.unsetActiveMenu();
    }

    openRichMenu() {
        this.showActiveMenu();
        this.showRichMenu();
    }

    allowBodyScroll() {
        this.ui.$body.classList.remove('is-unscrollable');
    }

    preventBodyScroll() {
        this.ui.$body.classList.add('is-unscrollable');
    }

}

export default HeaderModule;
